module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/visa-53b16597dadc65604e0813f44994a9b8.svg";